import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import DropDownComponent from "../DropDownComponent";
import InputComponent from "../InputComponent";
import TextFieldComponentLarge from "../TextFieldComponentLarge";
import RatingComponent from "../RatingComponent";
import TopTitleFormComponent from "./TopTitleFormComponent";
import DatePickerComponent from "../DatePickerComponent";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "@mui/material";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { updateDoc, doc as firestoreDoc } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";
import DropDownAllStaffs from "../Dropdowns/DropDownAllStaffs";
import { useEffect } from "react";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";

function AddDischargeReport(props) {
  //STATES

  const { currentUser } = useAuth();
  const [clientIdState, setClientIdState] = useState(props.clientId);
  const [isLoading, setIsLoading] = useState(false);
  const [dischargeDate, setDischargeDate] = useState(null);
  const [dischargeType, setDischargeType] = useState("");
  const [dischargeTo, setDischargeTo] = useState("");
  const [medication, setMedication] = useState("");
  const [issuesUponAdmission, setIssuesUponAdmission] = useState("");
  const [emergingIssues, setEmergingIssues] = useState("");
  const [progress, setProgress] = useState("");
  const [familyInvolvement, setFamilyInvolvement] = useState("");
  const [roadblocks, setRoadblocks] = useState("");
  const [clientPrognosis, setClientPrognosis] = useState("");
  const [dischargePlan, setDischargePlan] = useState("");
  const [staffMemberName, setStaffMemberName] = useState(
    currentUser.displayName
  );
  // const [signatureData, setSignatureData] = useState(null);
  const [rating, setRating] = useState(0);
  const [, setSignatureDataURL] = useState(null);
  // const [isSignatureStarted, setIsSignatureStarted] = useState(false);
  const [dischargeTypeOther, setDischargeTypeOther] = useState("");
  const [dischargeToOther, setDischargeToOther] = useState("");
  // const [isSignatureValidated, setIsSignatureValidated] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState("");
  const [dateOfAdmission, setDateOfAdmission] = useState(
    "" || props.dateOfAdmission
  );
  const [lengthOfStay, setLengthOfStay] = useState("");

  //FUNCTIONS

  const handleDischargeTypeOther = (event) => {
    setDischargeTypeOther(event);
  };
  const handleDischargeToOther = (event) => {
    setDischargeToOther(event);
  };

  const handleSelectedTherapistChange = (value) => {
    setSelectedTherapist(value);
  };

  const handleDischargeDateChange = (event) => {
    setDischargeDate(event);
  };

  const handleDischargeTypeChange = (event) => {
    setDischargeType(event);
  };

  const handleDischargeToChange = (event) => {
    setDischargeTo(event);
  };

  const handleMedicationChange = (event) => {
    setMedication(event);
  };

  const handleIssuesUponAdmissionChange = (event) => {
    setIssuesUponAdmission(event);
  };

  const handleEmergingIssuesChange = (event) => {
    setEmergingIssues(event);
  };

  const handleProgressChange = (event) => {
    setProgress(event);
  };

  const handleFamilyInvolvementChange = (event) => {
    setFamilyInvolvement(event);
  };

  const handleRoadblocksChange = (event) => {
    setRoadblocks(event);
  };

  const handleClientPrognosisChange = (event) => {
    setClientPrognosis(event);
  };

  const handleDischargePlanChange = (event) => {
    setDischargePlan(event);
  };

  const handleRatingChange = (event) => {
    setRating(event);
  };

  useEffect(() => {
    const loadData = async () => {
      const dischargeFormsRef = collection(db, "dischargeForms");
      const dischargeFormDocRef = doc(dischargeFormsRef, clientIdState);
      const docData = await getDoc(dischargeFormDocRef);

      if (docData.exists()) {
        const data = docData.data();

        setClientIdState(data.clientIdState || props.clientId);
        setDischargeDate(data.dischargeDate || null);
        setDischargeType(data.dischargeType || "");
        setDischargeTo(data.dischargeTo || "");
        setMedication(data.medication || "");
        setIssuesUponAdmission(data.issuesUponAdmission || "");
        setEmergingIssues(data.emergingIssues || "");
        setProgress(data.progress || "");
        setFamilyInvolvement(data.familyInvolvement || "");
        setRoadblocks(data.roadblocks || "");
        setClientPrognosis(data.clientPrognosis || "");
        setDischargePlan(data.dischargePlan || "");
        setStaffMemberName(data.staffMemberName || currentUser.displayName);
        setRating(data.rating || 0);
        setSignatureDataURL(data.signatureDataURL || null);
        setDischargeTypeOther(data.dischargeTypeOther || "");
        setDischargeToOther(data.dischargeToOther || "");
        setSelectedTherapist(data.selectedTherapist || "");
        setDateOfAdmission(data.dateOfAdmission || props.dateOfAdmission);
        setLengthOfStay(data.lengthOfStay || "");
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientIdState]);

  useEffect(() => {
    if (dischargeDate && dateOfAdmission) {
      let admissionDate;
      let discharge;

      // Vérifier si dischargeDate est un timestamp Firestore et le convertir en Date
      if (dischargeDate.seconds) {
        discharge = new Date(dischargeDate.seconds * 1000);
      } else {
        discharge = new Date(dischargeDate);
      }

      // Vérifier si dateOfAdmission est un timestamp Firestore et le convertir en Date
      if (dateOfAdmission.seconds) {
        admissionDate = new Date(dateOfAdmission.seconds * 1000);
      } else {
        admissionDate = new Date(dateOfAdmission);
      }

      // Vérifier si les deux dates sont valides
      if (!isNaN(admissionDate.getTime()) && !isNaN(discharge.getTime())) {
        // Calcul de la différence en jours (date de décharge - date d'admission)
        const timeDifference = discharge - admissionDate;
        const daysDifference = Math.ceil(
          timeDifference / (1000 * 60 * 60 * 24)
        );

        // Si la différence est négative, on la convertit en positive
        setLengthOfStay(`${Math.abs(daysDifference)} days`);
      } else {
        setLengthOfStay("Invalid dates");
      }
    }
  }, [dischargeDate, dateOfAdmission]);

  const [isSavingModifications, setIsSavingModifications] = useState(false);

  const handleSaveModifications = async () => {
    setIsSavingModifications(true);

    try {
      // const signatureURL = signatureDataURL ? await uploadSignature() : null;

      const dischargeData = {
        dischargeDate,
        dischargeTypeOther,
        dischargeType,
        dischargeTo,
        dischargeToOther,
        medication,
        issuesUponAdmission,
        emergingIssues,
        progress,
        familyInvolvement,
        roadblocks,
        clientPrognosis,
        dischargePlan,
        staffMemberName,
        selectedTherapist,
        // signatureData: signatureURL,
        rating,
        lengthOfStay,
        dateOfAdmission,
      };

      const dischargeFormsRef = collection(db, "dischargeForms");
      const dischargeFormDocRef = doc(dischargeFormsRef, clientIdState);

      await setDoc(dischargeFormDocRef, dischargeData);

      showCustomToast("Modifications saved successfully!", "success");

      setIsLoading(false);
    } catch (error) {
      showCustomToast("Error saving modifications", "error");
      console.error("Error saving modifications:", error);
      setIsLoading(false);
    }
    setIsSavingModifications(false);
    props.closemodal();
  };

  const handleFormSubmit = async () => {
    if (dischargeDate && dischargeType && dischargeTo) {
      setIsLoading(true);

      try {
        // const signatureURL = await uploadSignature();

        const dischargeData = {
          dischargeDate,
          dischargeTypeOther,
          dischargeType,
          dischargeTo,
          dischargeToOther,
          medication,
          issuesUponAdmission,
          emergingIssues,
          progress,
          familyInvolvement,
          roadblocks,
          clientPrognosis,
          dischargePlan,
          staffMemberName,
          selectedTherapist,
          // signatureData: signatureURL,
          rating,
          lengthOfStay,
          dateOfAdmission,
          signedOn: serverTimestamp(),
        };

        const dischargeFormsRef = collection(db, "dischargeForms");
        const dischargeFormDocRef = doc(dischargeFormsRef, clientIdState);

        await setDoc(dischargeFormDocRef, dischargeData);

        const clientDocRef = firestoreDoc(db, "clients", clientIdState);
        await updateDoc(clientDocRef, {
          DischargeReportOk: true,
          DischargeReportDateSigned: serverTimestamp(),
        });

        showCustomToast("Discharge form correctly submitted!", "success");

        setIsLoading(false);
        props.closemodal();
      } catch (error) {
        showCustomToast("Error submitting form", "error");

        console.error("Error submitting form:", error);
        setIsLoading(false);
      }
    } else {
      showCustomToast(
        "Some mandatory fields are missing, please check",
        "error"
      );

      console.error("All required fields must be filled out.");
    }
  };

  const isAddButtonDisabled = !dischargeDate || !dischargeType || !dischargeTo;

  const clientDisplayName =
    [props.firstName, props.lastName].filter(Boolean).join(" ") ||
    props.clientName ||
    "Client";
  // || !signatureDataURL;
  // ||
  // !isSignatureValidated;

  return (
    <>
      <div
        // className="inputAndLabelModalContainerTitle2"
        className="admission-document-shell admission-card-form-shell"
      >
        <TopTitleFormComponent
          title="Discharge summary / Report"
          eyebrow="ADMISSION FORM"
          subtitle={clientDisplayName}
          closemodal={props.closemodal}
        />

        <div className="admission-document-body">
          <div className="tab-form-container">
            <DatePickerComponent
              title="Discharge date"
              width="300"
              isRequired={true}
              value={dischargeDate}
              onChange={handleDischargeDateChange}
            />

            <DropDownComponent
              api="dischargeType"
              title="Discharge type"
              isRequired={true}
              value={dischargeType}
              onChange={handleDischargeTypeChange}
            />

            {dischargeType === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={dischargeTypeOther}
                onChange={handleDischargeTypeOther}
              />
            ) : (
              ""
            )}

            <DropDownComponent
              api="dischargeTo"
              title="Discharge to"
              value={dischargeTo}
              isRequired={true}
              onChange={handleDischargeToChange}
            />

            {dischargeTo === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={dischargeToOther}
                onChange={handleDischargeToOther}
              />
            ) : (
              ""
            )}
          </div>

          <div className="tab-form-container">
            <DropDownAllStaffs
              title="Assigned Therapist"
              value={selectedTherapist}
              width="auto"
              onChange={handleSelectedTherapistChange}
            />

            <DatePickerComponent
              title="Date of admission"
              width="150px"
              value={dateOfAdmission}
              // onChange={handleDateOfAdmission}
            />

            <InputComponent
              title="Total length of stay"
              width="150px"
              value={lengthOfStay}
              // onChange={handleLengthOfStay}
            />
          </div>

          <div className="tab-form-container">
            <TextFieldComponentLarge
              title="Medication prescribed upon discharge"
              value={medication}
              onChange={handleMedicationChange}
            />
            <TextFieldComponentLarge
              title="Identified issues upon admission"
              value={issuesUponAdmission}
              onChange={handleIssuesUponAdmissionChange}
            />
            <TextFieldComponentLarge
              title="Emerging issues identified during treatment"
              value={emergingIssues}
              onChange={handleEmergingIssuesChange}
            />

            <RatingComponent value={rating} onChange={handleRatingChange} />

            <TextFieldComponentLarge
              title="Progress"
              value={progress}
              onChange={handleProgressChange}
            />
            <TextFieldComponentLarge
              title="Family / significant Other Involvement"
              value={familyInvolvement}
              onChange={handleFamilyInvolvementChange}
            />
            <TextFieldComponentLarge
              title="Roadblocks/Concerns"
              value={roadblocks}
              onChange={handleRoadblocksChange}
            />
            <TextFieldComponentLarge
              title="Client prognosis"
              value={clientPrognosis}
              onChange={handleClientPrognosisChange}
            />
            <TextFieldComponentLarge
              title="Recommended Discharge Plan"
              value={dischargePlan}
              onChange={handleDischargePlanChange}
            />
            <InputComponent
              title="Staff Member Name"
              value={staffMemberName}
              // onChange={handleStaffMemberNameChange}
            />
            {/* <SignaturePadComponent
              onSignatureSave={handleSignatureSave}
              signatureDataURL={signatureDataURL}
              onSignatureStart={() => setIsSignatureStarted(true)}
              onSignatureValidate={setIsSignatureValidated}
            /> */}
          </div>
        </div>
        <StandardDrawerFooter className="admission-document-footer">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSaveModifications}
              style={{
                backgroundColor: isSavingModifications
                  ? "lightgrey"
                  : "#FFC107",
                color: "black",
                marginLeft: "15px",
              }}
              disabled={isSavingModifications}
            >
              {isSavingModifications
                ? "Saving Modifications..."
                : "Save Modifications"}
            </Button>

            <Button
              variant="contained"
              onClick={handleFormSubmit}
              style={
                isLoading
                  ? {
                      backgroundColor: "red",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : isAddButtonDisabled
                  ? {
                      backgroundColor: "lightgrey",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : {
                      backgroundColor: "#1565C0",
                      color: "white",
                      marginLeft: "15px",
                    }
              }
              disabled={isLoading || isAddButtonDisabled}
            >
              {isLoading ? "SUBMITTING..." : "SUBMIT"}
            </Button>
          </>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default AddDischargeReport;
